// const API_KEY = 'AIzaSyD_kc4SaC47DMdkGGGE_CqJ2IY6Fu70nkg'
const API_KEY = 'AIzaSyAegNOAcmaD8OzAYprGx8iLjCGG8zcH4TQ'
const CALLBACK_NAME = 'gmapsCallback'

let initialized = !!window.google
let resolveInitPromise
let rejectInitPromise

const initPromise = new Promise((resolve, reject) => {
  resolveInitPromise = resolve
  rejectInitPromise = reject
})

const googleMapInit = () => {
  if (initialized) return initPromise

  initialized = true
  window[CALLBACK_NAME] = () => resolveInitPromise(window.google)

  const markerClusterScript = document.createElement('script')
  markerClusterScript.async = true
  markerClusterScript.defer = true
  markerClusterScript.src = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js'
  document.querySelector('head').appendChild(markerClusterScript)

  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places&callback=${CALLBACK_NAME}`

  script.onerror = rejectInitPromise
  document.querySelector('head').appendChild(script)

  return initPromise
}

const defaultCenter = {
  lat: 30.26715,
  lng: -97.74306
}

export {
  googleMapInit,
  defaultCenter
}
